/**
 * useMediaTabs.js
 * ─────────────────────────────────────────────────────────────
 * IJ:       IJ-247 · Phase 5E-1 · Query Thread Render Extraction · sub-slice one of three
 * Date:     2026-08-02
 * Umbrella: IJ-076 · Predictive Text Rebuild continuation · Refactor Programme 2026 · Phase 5E
 * Owner:    E1
 *
 * Purpose:
 *   Extract the four media-tab state pieces out of KnowledgeGraphPage.jsx into
 *   a tiny state-only hook so that the coming QueryThread.jsx extraction (Phase
 *   5E-3) consumes a stable hook API instead of a hand-rolled prop bag.
 *
 * State owned:
 *   - mediaTab      { [idx]: 'web' | 'images' | 'videos' }
 *   - mediaCache    { [idx]: { images?: [...], videos?: [...] } }
 *   - mediaLoading  { [idx]: 'images' | 'videos' | null }
 *   - mediaError    { [idx]: { images?: msg, videos?: msg } }
 *
 * Byte-verbatim on every default value. Zero behaviour change.
 *
 * A resetAll helper is exposed for the three sites that currently batch-reset
 * all four states in one shot. Those sites keep their inline pattern in IJ-247
 * to preserve byte-verbatim call diffs. A future micro-slice may migrate them.
 */
import { useState, useCallback } from 'react';

export default function useMediaTabs() {
  const [mediaTab, setMediaTab] = useState({});
  const [mediaCache, setMediaCache] = useState({});
  const [mediaLoading, setMediaLoading] = useState({});
  const [mediaError, setMediaError] = useState({});

  const resetAll = useCallback(() => {
    setMediaTab({});
    setMediaCache({});
    setMediaLoading({});
    setMediaError({});
  }, []);

  return {
    mediaTab, setMediaTab,
    mediaCache, setMediaCache,
    mediaLoading, setMediaLoading,
    mediaError, setMediaError,
    resetAll,
  };
}
